import tinycolor from 'tinycolor2';

let primary = '#536DFE';
let secondary = '#8698FE';
const warning = '#FFC260';
const success = '#3CD4A0';
const info = '#9013FE';

let lightenRate = 7.5;
let darkenRate = 15;

const config = {
  US_SEC: ['#536DFE', '#8698FE', 7.5, 15],
  US_CRY: ['#FF6C8F', '#FFB8C9', 7.5, 5],
  BS_CRY: ['#18C69D', '#74E7C1', 7.5, 15],
  BS_SEC: ['#EB3D31', '#FF8686', 7.5, 15],
  JP_SUB_SEC: ['#B823D8', '#E363FF', 7.5, 15],
  CA_SUB_SEC: ['#F08234', '#FFB679', 7.5, 15],
  ASIA_SUB_SEC: ['#188910', '#20B715', 7.5, 15],
  FCM: ['#00B8D4', '#62EFFF', 7.5, 15],
}[window.env.LEDGIE_TYPE];

if (config) {
  [primary, secondary, lightenRate, darkenRate] = config;
}

let bgDefault = '#F6F7FF';
let bgLight = '#F3F5FF';
if (window.env.IS_PAPER) {
  bgDefault = '#F6F7EE';
  bgLight = '#F3F5DE';
}

export { primary, secondary };

export default {
  palette: {
    primary: {
      main: primary,
      light: tinycolor(primary)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(primary)
        .darken(darkenRate)
        .toHexString(),
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(secondary)
        .darken(darkenRate)
        .toHexString(),
      contrastText: '#FFFFFF',
    },
    warning: {
      main: warning,
      light: tinycolor(warning)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(warning)
        .darken(darkenRate)
        .toHexString(),
    },
    success: {
      main: success,
      light: tinycolor(success)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(success)
        .darken(darkenRate)
        .toHexString(),
    },
    info: {
      main: info,
      light: tinycolor(info)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(info)
        .darken(darkenRate)
        .toHexString(),
    },
    text: {
      primary: '#4A4A4A',
      secondary: '#6E6E6E',
      hint: '#B9B9B9',
    },
    background: {
      default: bgDefault,
      light: bgLight,
    },
  },
  customShadows: {
    widget:
      '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetDark:
      '0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetWide:
      '0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
  },
  overrides: {
    MuiBackdrop: {
      root: {
        backgroundColor: '#4A4A4A1A',
      },
    },
    MuiMenu: {
      paper: {
        boxShadow:
          '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
      },
    },
    MuiSelect: {
      icon: {
        color: '#B9B9B9',
      },
    },
    MuiListItem: {
      root: {
        '&$selected': {
          backgroundColor: '#F3F5FF !important',
          '&:focus': {
            backgroundColor: '#F3F5FF',
          },
        },
      },
      button: {
        '&:hover, &:focus': {
          backgroundColor: '#F3F5FF',
        },
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: 'white',
      },
    },
    MuiTableRow: {
      root: {
        height: 56,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: '1px solid rgba(224, 224, 224, .5)',
      },
      head: {
        fontSize: '0.95rem',
      },
      body: {
        fontSize: '0.95rem',
      },
    },
  },
};
